const paths = {
  ROOT: '/',
  DASHBOARD: 'dashboard',
};

export default paths;
